<template>
    <div>
        <div>
            <img style="cursor: pointer;" width="100%" src="https://alistatic.54traveler.com/werulepc/banner.jpg">
        </div>

        <div class="container" style="margin-top: 40px;margin-bottom: 40px;">
            <div class="row" style="height: 40px;">
                <div class="hborder">&nbsp;</div>
            </div>
            <div class="row toprule" >
                为了欢迎更多新伙伴和老朋友来参与<br>
                稻稻为大家准备了满满的福利哦！<br>
                以下所有福利<br>
                只要参加带有&nbsp;&nbsp;<span style="color: #cb091f;background-color: #f2f4f9;">“新人立减¥50”</span>&nbsp;&nbsp;<span style="color: #cb091f;background-color: #f2f4f9;">“全额返现”</span>&nbsp;&nbsp;的活动就能享受！<br>
                首先，你是萌新还是老稻呀<br>
                萌新：从没参与过稻草人的任何活动的；<br>
                老稻：曾参与过稻草人任意活动的都算；<br>
            </div>
            <div style="width: 38%;height: 180px;margin: 0 auto;" >
                <img style="cursor: pointer;width: 80px;float:left;" src="https://alistatic.54traveler.com/werulepc/iamnew.png">
                <img style="cursor: pointer;width: 80px;float: right;" src="https://alistatic.54traveler.com/werulepc/iamold.png" >
            </div>
            <div class="row" style="height: 40px;">
                <div class="hborder-bottom" style="background-color: #f2f4f9;height: 2px;">&nbsp;</div>
            </div>
            <div class="row" style="min-height: 40px;margin: 0 auto;width: 50%;">
                <img src="https://alistatic.54traveler.com/werulepc/title1.png" style="width: 100%;margin: 0px auto;">
            </div>

            <div class="row" style="min-height: 40px;width: 80%;margin: 2em auto;background-color: #f2f4f9;border-radius: 25px;">
                <div class="row" style="width: 80%;margin: 3em auto 1em;">
                    <img style="cursor: pointer;width: 25px;" src="https://alistatic.54traveler.com/werulepc/doubleright.png">
                    &nbsp;&nbsp;&nbsp;&nbsp;你将得到两个福利哟：
                </div>
                <div class="row" style="width: 80%;margin: 2em auto;">
                    <div style="cursor: pointer;width:40%;float:left;">
                        <img style="width: 300px" src="https://alistatic.54traveler.com/werulepc/newrule1.png">
                    </div>
                    <div style="cursor: pointer;width:20%;float:left;">
                        <img style="width: 90px;margin: 8em 3.2em;" src="https://alistatic.54traveler.com/werulepc/add.png">
                    </div>
                    <div style="cursor: pointer;width:40%;float:left;">
                        <img style="width: 300px" src="https://alistatic.54traveler.com/werulepc/newrule2.png" >
                    </div>
                </div>
            </div>

            <div class="row" style="min-height: 40px;margin: 0 auto;width: 50%;">
                <img src="https://alistatic.54traveler.com/werulepc/title2.png" style="width: 100%;margin: 0px auto;">
            </div>
            <div class="row" style="min-height: 40px;width: 80%;margin: 2em auto;background-color: #f2f4f9;border-radius: 25px;">
                <div class="row" style="width: 80%;margin: 3em auto 1em;">
                    <img style="cursor: pointer;width: 25px;" src="https://alistatic.54traveler.com/werulepc/doubleright.png">
                    &nbsp;&nbsp;&nbsp;&nbsp;稻稻也不会亏待了老队员哦，同样也可以拿到全额返现券！
                </div>
                <div class="row" style="width: 80%;margin: 2em auto;">
                    <img style="width: 100%" src="https://alistatic.54traveler.com/werulepc/oldrule.png" >
                </div>
            </div>

            <div class="row" style="min-height: 40px;margin: 0 auto;width: 50%;">
                <img src="https://alistatic.54traveler.com/werulepc/title3.png" style="width: 100%;margin: 0px auto;">
            </div>
            <div class="row" style="min-height: 40px;width: 80%;margin: 2em auto;background-color: #f2f4f9;border-radius: 25px;">
                <div class="row" style="width: 80%;margin: 3em auto 1em;">
                    <img style="cursor: pointer;width: 25px;" src="https://alistatic.54traveler.com/werulepc/doubleright.png">
                    &nbsp;&nbsp;&nbsp;&nbsp;除了城市活动之外，小伙伴们参与稻草人的旅行路线（4天及以上） 旅行结束后也会送你一张福利券哦！
                </div>
                <div class="row" style="width: 80%;margin: 2em auto;">
                    <div style="cursor: pointer;width:300px;margin: 1em auto;">
                        <img style="width: 300px;" src="https://alistatic.54traveler.com/werulepc/fouroldrule.png">
                    </div>
                    <!-- <div style="cursor: pointer;width:20%;float:left;">
                        <img style="width: 90px;margin: 8em 3.2em;" src="https://alistatic.54traveler.com/werulepc/add.png">
                    </div>
                    <div style="cursor: pointer;width:40%;float:left;">
                        <img style="width: 300px" src="https://alistatic.54traveler.com/werulepc/fournewrule.png" >
                    </div> -->
                </div>
            </div>

            <div class="row" style="min-height: 100px;width: 80%;margin: 2em auto;background-color: #cb091f;">
                <div class="row" style="min-height: 100px;width: 90%;margin: 2em auto;background-color: #ffffff;border-radius: 25px;">
                    <div style="width: 100%;text-align: center;">
                        <h2 style="text-align: center;font-size: 24px;">福利详细说明，划重点一定要仔细看哟！</h2>
                        <h2 style="color: #cb091f;font-size: 20px;text-align: center;line-height: 32px;width: 90%;margin: 0 auto;">前提：所有福利，都是针对带有“新人立减50”和“全额返现”两个标签的城市活动哦~</h2>
                    </div>
                    <div style="width: 100%;">
                        <div style="width: 210px;background-color: #cb091f;color: #ffffff;font-size: 18px;border-radius: 25px;margin-top: 1em;text-align: right;margin-left: -1em;">
                            福利一：新人立减50！
                        </div>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 1em auto;line-height: 32px;font-weight: 400;">
                            没有参与过稻草人任何活动的小伙伴，只要报名参加带有“新人立减50”标签的城市活动，<span style="color: #cb091f;">在报名时直接立减50！</span>
                        </h2>
                    </div>

                    <div style="width: 100%;">
                        <div style="width: 310px;background-color: #cb091f;color: #ffffff;font-size: 18px;border-radius: 25px;margin-top: 1em;margin-bottom: 1em;text-align: right;margin-left: -1em;">
                            福利二：全额返现，抵扣旅行费用！
                        </div>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 0em auto;line-height: 32px;font-weight: 400;">
                            所有小伙伴，只要参与带有“全额返现”标签的城市活动，在每个活动结束后，<span style="color: #cb091f;">都可以获得一张活动金额的等额现金抵扣券！</span>以下简称返现券，使用规则如下——
                        </h2>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 0em auto;line-height: 32px;font-weight: 400;">
                            <span style="width: 10px;height:10px;background-color: #cb091f;color: #ffffff;border-radius: 5px;text-align: center;">
                            &nbsp;1&nbsp;
                            </span>
                            &nbsp;在报名稻草人旅行4天及以上路线时可以使用，直接抵扣减免团费~
                        </h2>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 0em auto;line-height: 32px;font-weight: 400;">
                            <span style="width: 10px;height:10px;background-color: #cb091f;color: #ffffff;border-radius: 5px;text-align: center;">
                            &nbsp;2&nbsp;
                            </span>
                            &nbsp;可以选择叠加使用，但上限为5张；
                        </h2>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 0em auto;line-height: 32px;font-weight: 400;">
                            <span style="width: 10px;height:10px;background-color: #cb091f;color: #ffffff;border-radius: 5px;text-align: center;">
                            &nbsp;3&nbsp;
                            </span>
                            &nbsp;返现券有效期一年，且国庆也可用哦；
                        </h2>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 0em auto;line-height: 32px;font-weight: 400;">
                            <span style="width: 10px;height:10px;background-color: #cb091f;color: #ffffff;border-radius: 5px;text-align: center;">
                            &nbsp;4&nbsp;
                            </span>
                            &nbsp;同一个城市活动无论参加几次都只有1张券哦，尽量多解锁不同活动吧~
                        </h2>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 0em auto;line-height: 32px;font-weight: 400;">
                            <span style="width: 10px;height:10px;background-color: #cb091f;color: #ffffff;border-radius: 5px;text-align: center;">
                            &nbsp;5&nbsp;
                            </span>
                            &nbsp;在参与城市活动后，返现券将在5个工作日内发放到你的账户；
                        </h2>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 1em auto;line-height: 32px;font-weight: 400;color: #cb091f;">
                            举个栗子，比如参加了79元的摩登外滩、79元的虹口方舟、79元的黄金时代，那报名4天的1280的徒步武功山，即可直接立减237元！
                        </h2>
                    </div>
                    <div style="width: 100%;">
                        <div style="width: 450px;background-color: #cb091f;color: #ffffff;font-size: 18px;border-radius: 25px;margin-top: 1em;text-align: right;margin-left: -1em;">
                            福利三：参与稻稻常规旅行（4天及以上）也送福利！
                        </div>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 1em auto;line-height: 32px;font-weight: 400;">
                            如果你参与了稻稻4天及以上的旅行路线，包括超级周末、长线、国际线，也有福利哦！在旅行结束后你也会得到一张福利券
                        </h2>
                        <h2 style="text-align: left;font-size: 16px;width: 90%;margin: 1em auto;line-height: 32px;font-weight: 400;">
                            <span style="width: 10px;height:10px;background-color: #cb091f;color: #ffffff;border-radius: 5px;text-align: center;">
                            &nbsp;1&nbsp;
                            </span>
                            &nbsp;<span style="color: #cb091f;">【同行体验券】</span>：拉上一位没有参与过稻草人的新人，一起报名带有“新人立减50”和“全额返现”标签的活动，<span style="color: #cb091f;">那么你就直接免费，新人则享受立减50的福利，结束后你们还能各自得到一张返现券（规则同上），可以再下次报名用！</span>
                        </h2>
                    </div>
                    <div style="width: 100%;text-align: center;">
                        <h2 style="color: #cb091f;font-size: 20px;text-align: center;line-height: 32px;width: 90%;margin: 1em auto;">
                            *活动最终解释权归稻草人旅行所有
                        </h2>
                    </div>
                </div>
            </div>





        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        textShow: false
      }
    },
    methods: {
      goSecond () {
        var url = '/'
        window.open(url)
      },
      lookthis () {
        this.textShow = true
      }
    }
  }
</script>
<style scoped>
    .container{
      width: 1000px;
    }
    .we-part{
      padding-top: 55px;
      padding-bottom: 80px;
    }
    .we-part img{
      width: 100%;
      height: 100%;
    }
    .we-part:nth-child(odd){
      background-color: #fff;
    }
    .we-part:nth-child(even){
      background-color: #fbfbfb;
    }
    .we-part .container:nth-child(2){
      padding: 0;
    }
    h2{
      font-weight: bold;
      margin-bottom: 20px;
      text-align: left;
      font-size: 24px;
    }
    .col-xs-10.col-xs-offset-1{
      margin-bottom: 45px;
    }
    .hborder {
        background-color: black;
        width: 30px;
        height: 4px;
        border-radius: 4px;
        margin: 0 auto;
    }
    .toprule {
        width: 80%;
        min-height: 200px;
        margin:0 auto;
        color:#2d2d2d;
        font-weight: bold;
        font-size: 20px;
        text-align: center;
        margin-bottom: 20px;
    }
    .hborder-bottom {
        color:#f2f4f9;
        background-color: black;
        width: 80%;
        height: 4px;
        border-radius: 4px;
        margin: 0 auto;
    }
</style>



/** WEBPACK FOOTER **
 ** weRule.vue?610c1952
 **/